const popupModalElement = document.getElementById('popupModal')
const bootstrapModal = new bootstrap.Modal(popupModalElement)

if (popupModalElement) {
  const localStorageKey = 'popupModalDismissed';

  if (localStorage.getItem(localStorageKey) !== 'true') {
    bootstrapModal.show();
  }

  popupModalElement.addEventListener('hide.bs.modal', event => {
    localStorage.setItem(localStorageKey, 'true');
  })
}
